import { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../data/i18n';

const LanguageContext = createContext(null);

const STORAGE_KEY = 'sleepstack.lang';

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            return saved === 'nl' || saved === 'en' ? saved : 'nl';
        } catch {
            return 'nl';
        }
    });

    useEffect(() => {
        try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* ignore */ }
    }, [lang]);

    const setLang = (l) => setLangState(l);

    const t = (key, vars) => {
        const keys = key.split('.');
        let val = translations[lang];
        for (const k of keys) {
            val = val?.[k];
        }
        let out = val || key;
        if (vars && typeof out === 'string') {
            out = out.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) =>
                vars[name] !== undefined ? String(vars[name]) : ''
            );
        }
        return out;
    };

    const toggleLang = () => setLangState(l => l === 'en' ? 'nl' : 'en');

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
    return ctx;
};
